import { faShield } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { memo } from 'react';

import { Props } from './types';

/**
 * @deprecated Do not use this component. Use the base components at the root of the UI folder instead.
 */
const AlertBanner = ({ text }: Props) => {
  return (
    <div className="flex items-center border border-uniform-green-700 rounded dark:bg-uniform-green-900 dark:text-uniform-white-base light:bg-uniform-green-50 light:text-uniform-green-900 p-4 font-roboto">
      <div className="mr-4">
        <FontAwesomeIcon icon={faShield} className="text-green-500 fa-2x" />
      </div>

      <p className="text-sm">{text}</p>
    </div>
  );
};

export default memo(AlertBanner);
